module.exports = __webpack_public_path__ + "images/brochure-09bc303d6667250783d60feb2f4bd4ff.svg";